import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'state/store';

export type AuthenticationState = {
  isLoggedIn: boolean;
  data: {
    nepToken: string | null;
    uuaToken: string | null;
  };
};

export const initialState: AuthenticationState = {
  isLoggedIn: false,
  data: {
    nepToken: null,
    uuaToken: null
  }
};

export const slice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.isLoggedIn = initialState.isLoggedIn;
      state.data = initialState.data;
    },
    setLoggedIn: (state) => {
      state.isLoggedIn = true;
    },
    setLoggedOut: (state) => {
      state.isLoggedIn = false;
    },
    setData: (state, { payload }) => {
      state.data = payload;
    }
  }
});

export const {
  setInitialState,
  setLoggedIn,
  setLoggedOut,
  setData
} = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectIsLoggedIn = (state: RootState) =>
  selectSlice(state).isLoggedIn;
export const selectData = (state: RootState) => selectSlice(state).data;
export const selectNepToken = (state: RootState) => selectData(state).nepToken;
export const selectUuaToken = (state: RootState) => selectData(state).uuaToken;

export default slice.reducer;
